var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause = function SvgIconPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75.333c.92 0 1.667.747 1.667 1.667v10a1.667 1.667 0 0 1-3.334 0V2c0-.92.747-1.667 1.667-1.667m-7.5 0c.92 0 1.667.747 1.667 1.667v10a1.667 1.667 0 1 1-3.334 0V2c0-.92.747-1.667 1.667-1.667"
  })));
};
export default SvgIconPause;